import { computed, inject } from '@angular/core';
import { UserStore } from '../store/user.store';

/**
 * ✅ Select the full user profile.
 */
export function selectUserProfile(store:UserStoreType) {
  return computed(() => store.profile());
}

/**
 * ✅ Select user id only.
 */
export function selectUserId(store:UserStoreType) {
  return computed(() => store.profile()?.id ?? null);
}

/**
 * ✅ Select whether user is currently signed in.
 */
export function selectIsSignedIn(store:UserStoreType) {
  return computed(() => store.profile() != null);
}

/**
 * ✅ Select whether user is currently signing in.
 */
export function selectIsSigningIn(store:UserStoreType) {
  return computed(() => store.isSigningIn());
}

/**
 * ✅ Select whether user is currently signing out.
 */
export function selectIsSigningOut(store:UserStoreType) {
  return computed(() => store.isSigningOut());
}


/**
 * ✅ Select whether user profile is being updated.
 */
export function selectIsUpdating(store:UserStoreType) {
  return computed(() => store.isUpdating());
}

type UserStoreType = InstanceType<typeof UserStore>;
